module.exports = __webpack_public_path__ + "static/media/socialPiper-schedule-tablet-es.e8d3e0f9.png";